import { render } from "./App.vue?vue&type=template&id=2d2be0a8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2d2be0a8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__